import { render, staticRenderFns } from "./PurchaserManage.vue?vue&type=template&id=8fcbad6a&scoped=true&"
import script from "./PurchaserManage.vue?vue&type=script&lang=js&"
export * from "./PurchaserManage.vue?vue&type=script&lang=js&"
import style0 from "./PurchaserManage.vue?vue&type=style&index=0&id=8fcbad6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcbad6a",
  null
  
)

export default component.exports